import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import OwnedEntityPicker, {
  OwnedEntityPickerFieldSchema,
  validateOwnedEntity,
} from './OwnedEntityPickerExtension';

export const ownedEntityPickerField = {
  name: 'OwnedEntityPicker',
  component: OwnedEntityPicker,
  schema: OwnedEntityPickerFieldSchema,
  validation: validateOwnedEntity,
};

export const OwnedEntityPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    ...ownedEntityPickerField,
    schema: OwnedEntityPickerFieldSchema.schema,
  }),
);
